cockpitApp.directive('travelers', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/travelers',
    controllerAs: 'travelersCtrl',
    controller: 'travelersController'
  };
});
